export const UPDATES_LOG = [
    {
        version: '2.1.0',
        date: '2026-01-30',
        time: '16:00',
        category: 'ui',
        icon: '✨',
        title: 'شيمر لودينج احترافي',
        description: 'ضفنا شيمر لودينج (Skeleton Loading) لكل الصفحات. دلوقتي لما تفتح أي صفحة هتلاقي شكل منسق بيحمل قدامك بدل ما الصفحة تبقى فاضية!',
        details: 'اشتغلنا على 3 كومبوننتات جديدة (CardSkeleton، DashboardSkeleton، TableSkeleton) وطبقناهم على صفحات الأدوار والمستخدمين والداشبورد. كل شيمر بيطابق مقاسات الكاردات بالظبط عشان المظهر يبقى ناعم ومحترف.'
    },
    {
        version: '2.0.9',
        date: '2026-01-30',
        time: '15:55',
        category: 'bug',
        icon: '🔐',
        title: 'حلينا مشكلة صلاحيات السوبر أدمن',
        description: 'كان في مشكلة إن السوبر أدمن مش قادر يدخل على بعض الصفحات. صلحناها وخلينا الصلاحيات تشتغل على web و api مع بعض.',
        details: 'المشكلة كانت إن الأدوار (Roles) كانت بتتعمل بس لـ web guard، مش لـ api guard. دلوقتي كل رول بيتعمل للاتنين، والسوبر أدمن بقى عنده access كامل على كل حاجة!'
    },
    {
        version: '2.0.8',
        date: '2026-01-30',
        time: '15:52',
        category: 'bug',
        icon: '🛠️',
        title: 'صلحنا 240+ ملف Vue!',
        description: 'كان في warning بيظهر "Expected Array, got Boolean" في الـ console. صلحناه في كل الملفات بحيث الداتا الفاضية تبقى [] بدل false.',
        details: 'لقينا إن كل الكومبوننتات اللي فيها جداول كانت بتحط false لما الداتا تيجي فاضية بدل ما تحط []، وده كان بيعمل warnings في الـ console. دلوقتي صلحنا 240+ ملف دفعة واحدة!'
    },
    {
        version: '2.0.7',
        date: '2026-01-30',
        time: '04:00',
        category: 'bug',
        icon: '🔧',
        title: 'إصلاح شامل للصلاحيات',
        description: 'خلينا كل الصلاحيات تشتغل على web و api guards عشان نضمن إن مفيش حد يواجه مشاكل unauthorized.',
        details: 'حدثنا الـ PermissionsTableSeeder وعملنا sync للصلاحيات على كل الـ guards، وضمنا إن السوبر أدمن عنده كل الصلاحيات.'
    },
    {
        version: '2.0.6',
        date: '2026-01-30',
        time: '01:20',
        category: 'bug',
        icon: '⚙️',
        title: 'حلينا مشاكل الكاش والتشارتس',
        description: 'كان في مشاكل بتظهر في التشارتس والكاليندر. صلحناهم وعملنا cache busting عشان كل واحد ياخد أحدث نسخة.',
        details: 'ضفنا null checks في chart.js و main.js و calendar.js، وعملنا cache busting بإضافة timestamps للملفات عشان ما يحصلش مشاكل من الـ cache القديم.'
    },
    {
        version: '2.0.5',
        date: '2026-01-29',
        time: '23:10',
        category: 'feature',
        icon: '🌐',
        title: 'استبدلنا $t بـ Lang.get',
        description: 'غيرنا كل الكومبوننتات القديمة اللي كانت بتستخدم $t وخليناها تستخدم Lang.get عشان الترجمة تبقى أحسن.',
        details: 'كان في legacy code بيستخدم $t للترجمة، دلوقتي كل حاجة بتستخدم Lang.get اللي أحسن وأسرع.'
    },
    {
        version: '2.0.4',
        date: '2026-01-29',
        time: '20:56',
        category: 'feature',
        icon: '🎯',
        title: 'ديمو سيتب بتقدم حقيقي',
        description: 'لما تطبق الديمو بريست دلوقتي تقدر تشوف خطوة بخطوة إيه اللي بيحصل! مش مجرد لودر كاذب.',
        details: 'عملنا سيستم كامل بيوريك كل module بيتم seed إزاي، بال progress الحقيقي مش سيمولايشن. كمان ضفنا terminal style عصري وقوائم تقدم منظمة.'
    },
    {
        version: '2.0.3',
        date: '2026-01-29',
        time: '20:20',
        category: 'ui',
        icon: '🔔',
        title: 'التحديثات تظهر مرة واحدة بس',
        description: 'خلينا نوتيفكيشن التحديثات يظهر مرة واحدة على كل جهاز، مش كل مرة تفتح فيها الصفحة!',
        details: 'استخدمنا localStorage بحيث لو شفت التحديث مرة مش هيظهرلك تاني، إلا لو في version جديد.'
    },
    {
        version: '2.0.2',
        date: '2026-01-29',
        time: '14:15',
        category: 'bug',
        icon: '📚',
        title: 'صلحنا مشاكل الكتب',
        description: 'كان في باجات في صفحات الكتب وتفاصيلها. دلوقتي كل حاجة شغالة تمام.',
        details: 'حلينا مشاكل في book details والـ sidebar، وضبطنا الـ logo click.'
    },
    {
        version: '2.0.1',
        date: '2026-01-29',
        time: '06:35',
        category: 'feature',
        icon: '📋',
        title: 'سيستم ديناميك للمينو',
        description: 'عملنا سيستم جديد بيعمل seed للمينو items بشكل ديناميكي، مش هاردكود زي الأول!',
        details: 'دلوقتي كل menu items بيتم seed من الداتابيز، وده بيخليك تقدر تعدل المينو بسهولة من غير ما تمس في الكود.'
    },
    {
        version: '2.0.0',
        date: '2026-01-28',
        time: '18:05',
        category: 'feature',
        icon: '👥',
        title: 'Teams v1.0.0 - إدارة الفرق',
        description: 'أطلقنا feature جديد خالص للفرق! دلوقتي تقدر تعمل teams وتديرهم بسهولة.',
        details: 'أول نسخة من نظام إدارة الفرق، بكل الإمكانيات الأساسية اللي تحتاجها لتنظيم الشغل.'
    },
    {
        version: '1.9.5',
        date: '2026-01-28',
        time: '17:35',
        category: 'feature',
        icon: '🔊',
        title: 'حد للـ Text-to-Speech',
        description: 'خلينا الـ text to speech يشتغل بس للنصوص اللي أقل من 1000 حرف عشان ما نحملش السيرفر.',
        details: 'لو النص أطول من 1000 حرف مش هيشتغل معاك الـ speech، عشان نحافظ على الأداء.'
    },
    {
        version: '1.9.4',
        date: '2026-01-28',
        time: '16:10',
        category: 'bug',
        icon: '🚌',
        title: 'حلينا أخطاء الحافلات',
        description: 'صلحنا server errors كانت بتظهر في module الحافلات.',
        details: 'كان في exceptions بتطلع في بعض حالات استخدام الحافلات، دلوقتي كل حاجة smooth.'
    },
    {
        version: '1.9.3',
        date: '2026-01-27',
        time: '16:55',
        category: 'bug',
        icon: '🔑',
        title: 'ضبطنا صلاحيات Zatka',
        description: 'كان في مشكلة في الصلاحيات الخاصة بـ Zatka، دلوقتي كل حاجة تمام.',
        details: 'عدلنا الـ permissions عشان Zatka integration يشتغل صح.'
    },
    {
        version: '1.9.0',
        date: '2026-01-26',
        time: '13:45',
        category: 'feature',
        icon: '📝',
        title: 'فلاتر للقبول في الـ API',
        description: 'ضفنا إمكانية filtering للقبول (Admissions) من الـ API مباشرة.',
        details: 'دلوقتي تقدر تعمل filter للـ admissions من الـ API endpoints بسهولة.'
    },
    {
        version: '1.8.9',
        date: '2026-01-26',
        time: '11:35',
        category: 'ui',
        icon: '💰',
        title: 'شلنا زرار حذف الفاتورة والاسترداد',
        description: 'عشان الأمان، شلنا أزرار حذف الفواتير والاستردادات من الواجهة.',
        details: 'قررنا نمنع حذف الفواتير والـ refunds عشان نحافظ على سلامة البيانات المالية.'
    },
    {
        version: '1.8.8',
        date: '2026-01-26',
        time: '11:05',
        category: 'feature',
        icon: '🔢',
        title: 'رقم مرجعي للفواتير',
        description: 'كل فاتورة دلوقتي ليها رقم مرجعي (billing reference number) يتولد أوتوماتيك.',
        details: 'عشان نسهل التتبع، كل invoice بقى ليه unique reference number.'
    },
    {
        version: '1.8.7',
        date: '2026-01-26',
        time: '10:30',
        category: 'feature',
        icon: '🤖',
        title: 'دعم الذكاء الاصطناعي',
        description: 'ضفنا AI endpoints جديدة! دلوقتي النظام جاهز للتكامل مع features الذكاء الاصطناعي.',
        details: 'أضفنا endpoints جديدة للتكامل مع خدمات الـ AI، جاهزين للمستقبل!'
    },

    // باقي التحديثات السابقة...
    {
        version: '1.2.0',
        date: '2026-01-27',
        time: '12:00',
        category: 'feature',
        icon: '🇸🇦',
        title: 'سكولنا صار يتكلم لهجتك!',
        description: 'أضفنا اللهجة السعودية والكويتية بالكامل. الحين النظام "يحييك" بالسعودي و"يهلي" بك بالكويتي.',
        details: 'دعم كامل للهجة السعودية (ar_sa) والكويتية (ar_kw) مع كل الترجمات والتوطين الكامل.'
    },
    {
        version: '1.1.5',
        date: '2026-01-27',
        time: '11:30',
        category: 'performance',
        icon: '🚀',
        title: 'بروقنا النظام وصار طيارة',
        description: 'صلحنا مشاكل تحميل الملفات (Chunks) اللي كانت تظهر أحياناً. الحين التصفح صار أسلس وأسرع.',
        details: 'حلينامشاكل الـ chunk loading وحسنّا الأداء بشكل عام.'
    },
    {
        version: '1.1.0',
        date: '2026-01-27',
        time: '10:00',
        category: 'feature',
        icon: '✨',
        title: 'ذكاء في تبديل اللغة',
        description: 'النظام صار ذكي! يبدل لك اللغة والاتجاه (يمين/يسار) ويغير لك الـ CSS بلمحة عين.',
        details: 'تبديل ذكي للغة مع تغيير CSS والاتجاه أوتوماتيك بدون refresh.'
    },
    {
        version: '1.0.0',
        date: '2026-01-26',
        time: '09:00',
        category: 'bug',
        icon: '✅',
        title: 'ودعنا المشاكل التقنية',
        description: 'ضبطنا لودر اللغات وسوينا تنظيف شامل للكود عشان نضمن إن كل كلمة تظهر في مكانها الصحيح.',
        details: 'إصلاح شامل للـ language loader وتنظيف الكود.'
    }
];

// Category labels in Egyptian Arabic
export const CATEGORY_LABELS = {
    feature: 'ميزة جديدة',
    bug: 'إصلاحات',
    ui: 'تحسين الواجهة',
    performance: 'تحسين الأداء',
    security: 'أمان'
};

// Category colors
export const CATEGORY_COLORS = {
    feature: '#10b981',
    bug: '#ef4444',
    ui: '#8b5cf6',
    performance: '#f59e0b',
    security: '#3b82f6'
};
